// removed by extract-text-webpack-plugin
module.exports = {"root":"_13yme9acm-wvNygNQaLKCT","nav-bar":"_2Wg0p4hwW0Khd4pyA01pgd","muhimma":"_2ks-v9vC87MosI6bgNsVhD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/navigation.scss
// module id = 1414
// module chunks = 0